import { Component, Input } from '@angular/core';
import { DataQualityFlag } from '../../models/account-usage.model';
import { LanguageService } from '../../../../services/language/language.service';

const FLAG_PRIORITY: DataQualityFlag[] = [
  'source_unavailable',
  'usage_not_evaluated',
  'snapshot_stale',
  'source_error',
  'missing_subscription',
  'missing_model_policy',
  'legacy'
];

const FLAG_VARIANT: Record<string, 'warn' | 'info' | 'neutral'> = {
  source_unavailable: 'warn',
  source_error: 'warn',
  snapshot_stale: 'warn',
  usage_not_evaluated: 'info',
  missing_subscription: 'warn',
  missing_model_policy: 'info',
  legacy: 'neutral'
};

function isDisplayableFlag(flag: DataQualityFlag): boolean {
  return flag !== 'real' && !String(flag).startsWith('source:');
}

@Component({
  selector: 'app-usage-data-quality-pill',
  templateUrl: './usage-data-quality-pill.component.html',
  styleUrls: ['./usage-data-quality-pill.component.scss'],
  standalone: false
})
export class UsageDataQualityPillComponent {
  @Input() flags: DataQualityFlag[] | null = null;

  constructor(private readonly languageService: LanguageService) {}

  get primaryFlag(): DataQualityFlag | null {
    if (!Array.isArray(this.flags) || this.flags.length === 0) {
      return null;
    }
    for (const candidate of FLAG_PRIORITY) {
      if (this.flags.includes(candidate)) {
        return candidate;
      }
    }
    return this.flags.find(isDisplayableFlag) ?? null;
  }

  get variant(): 'warn' | 'info' | 'neutral' {
    const flag = this.primaryFlag;
    if (!flag) {
      return 'neutral';
    }
    return FLAG_VARIANT[flag] ?? 'neutral';
  }

  get label(): string {
    const flag = this.primaryFlag;
    if (!flag) {
      return '';
    }
    const key = `usage.flag.${flag}`;
    const translated = this.languageService.translate(key);
    if (translated && translated !== key) {
      return translated;
    }
    return flag.replace(/_/g, ' ');
  }
}
